import React from 'react';
import { Grid } from '@mui/material';
import {
    TextField,
    EmailField
} from '../../CommonComponents/Form';
import { SectionDivider } from '../../CommonComponents';

interface BillingInfoProps {
    entity: {
        billingEmail: string;
        billingMark: string;
        billingStreet: string;
        billingZip: string;
        billingCity: string;
    };
    onChange: (e: React.ChangeEvent<any>) => void;
}

const BillingInfoBlock = ({ entity, onChange }: BillingInfoProps) => (
    <Grid item md={12} lg={6}>
        <SectionDivider label="Faktureringsuppgifter" marginTop={2} marginBottom={0} />
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <EmailField
                    name="billingEmail"
                    label="E-post för faktura"
                    value={entity.billingEmail}
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="billingMark"
                    label="Märkning"
                    value={entity.billingMark}
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="billingStreet"
                    label="Gata"
                    value={entity.billingStreet}
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="billingZip"
                    label="Postnummer"
                    value={entity.billingZip}
                    onChange={onChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="billingCity"
                    label="Postort"
                    value={entity.billingCity}
                    onChange={onChange}
                />
            </Grid>
        </Grid>
    </Grid>
);

export default React.memo(BillingInfoBlock);
